var exports = {
  "kv": "SelectableSettingsList.module__checkbox___S2tUcn",
  "wb": "SelectableSettingsList.module__checkboxUnchecked___S2tUcn",
  "xY": "SelectableSettingsList.module__checkboxChecked___S2tUcn",
  "oE": "SelectableSettingsList.module__checkIcon___S2tUcn",
};

module.exports = exports;
